import { Badge, Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { MouseEvent } from 'react';
import { defaultClientsStatus, useClients } from '../context/ClientsProvider';
import { isSameIdSet } from 'utils/helpers/list/isSameIdSet';
import SolarIcon from 'components/icons/SolarIcon';

const clientStatuses = [0, 1];

const ClientFilterStatus = () => {
    const { t } = useTranslation(['Clients']);
    const { clientsStatus, setClientsStatus } = useClients();
    const filterActive = !isSameIdSet(clientsStatus, defaultClientsStatus);

    const handleClickStatus = (e: MouseEvent<HTMLElement>, statusID: number) => {
        e.currentTarget.blur();
        if (clientsStatus.includes(statusID)) {
            setClientsStatus((prev: number[]) => prev.filter((id) => id !== statusID));
        } else {
            setClientsStatus((prev: number[]) => [...prev, statusID]);
        }

        e.stopPropagation();
    };

    return (
        <Dropdown>
            <Dropdown.Toggle
                className="fs-14 px-2 ms-1"
                size="sm"
                variant={filterActive ? 'danger' : 'primary'}
                id="dropdown-clients-filter"
                title={t('toolFilterStatus')}
            >
                <SolarIcon name="funnel" className="fs-14 p-0" />
            </Dropdown.Toggle>

            <Dropdown.Menu>
                {clientStatuses.map((statusID) => (
                    <Dropdown.Item
                        key={statusID}
                        onClick={(e) => handleClickStatus(e, statusID)}
                    >
                        <div className="me-2">
                            <input
                                type="checkbox"
                                checked={clientsStatus.includes(statusID)}
                                onChange={() => null}
                                className="form-check-input"
                            />
                        </div>

                        <Badge className="fs-12" bg={statusID === 0 ? 'success' : 'secondary'}>
                            {t(`status.${statusID}`)}
                        </Badge>
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default ClientFilterStatus;
